exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3mAZ3{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;margin:10px 10px 6px}", ""]);

// exports
exports.locals = {
	"tooltipContainer": "_3mAZ3"
};